import mergeConfig from '../../externals/axios/core/mergeConfig';
import wrapRequest from './wrapRequest';
export default (function (axiosInstance, requestFn) {
    var request = wrapRequest(requestFn, axiosInstance);
    var instance = request;
    Object.keys(axiosInstance)
        .forEach(function (key) {
        instance[key] = axiosInstance[key];
    });
    ['get', 'head', 'options', 'delete'].forEach(function (method) {
        instance[method] = function (url, config) {
            return request(mergeConfig(config || {}, {
                url: url,
                method: method,
                data: (config || {}).data,
            }));
        };
    });
    ['post', 'put', 'patch'].forEach(function (method) {
        instance[method] = function (url, data, config) {
            return request(mergeConfig(config || {}, {
                url: url,
                data: data,
                method: method,
            }));
        };
    });
    instance['request'] = request;
    return instance;
});
//# sourceMappingURL=createRequestInstance.js.map